import { createContext, useContext, useState } from 'react';

const DirectionContext = createContext();

export const useDirection = () => useContext(DirectionContext);

export const DirectionProvider = ({ children }) => {
  const [direction, setDirection] = useState('ltr');

  return (
    <DirectionContext.Provider value={{ direction, setDirection }}>
      {children}
    </DirectionContext.Provider>
  );
};
